var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { H3 } from "@irati/ui/src/Headings";
import { Para } from "@irati/ui/src/Labels";
import { FormattedMessage, FormattedCurrency, FormattedDate, FormattedRelative, injectIntl } from "@irati/utils/lang";
import TenantWalletBalanceQuery from "@irati/wallet/apollo/query/TenantWallet";
import { TopUpTypes } from "@irati/wallet/enums";
import { BankName, BankAccountNumber, BankSortCode } from "@irati/wallet/constants/bankTransferDetails";
import { StyledModal, LeftAlign, TopCard, GreyCard, InnerCard, StyledButton } from "./styled";
import ModalHeader from "./ModalHeader";
import Row from "./Row";
var TopUpConfirmationPopup = /** @class */ (function (_super) {
    __extends(TopUpConfirmationPopup, _super);
    function TopUpConfirmationPopup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopUpConfirmationPopup.prototype.render = function () {
        var _a = this.props, onClose = _a.onClose, show = _a.show, details = _a.details, title = _a.title, mainMessage = _a.mainMessage, firstRow = _a.firstRow, secondRow = _a.secondRow, invoiceToMessage = _a.invoiceToMessage, messages = _a.messages, pending = _a.pending;
        var amount = details.amount, currency = details.currency, metadata = details.metadata;
        var createdAt = metadata.createdAt;
        var isBankTransfer = details.payment.type === TopUpTypes.BankTransfer;
        var dateText = isBankTransfer ? "wallet.tenant.topUp.invoicePopUp.dueDate" : "wallet.tenant.topUp.invoicePopUp.date";
        return (React.createElement(StyledModal, { show: show, useMobileStyling: false, onHide: onClose, onExited: onClose, renderHeader: function () { return React.createElement(ModalHeader, null); } },
            React.createElement(TopCard, { medium: true },
                React.createElement(H3, { small: true }, title),
                React.createElement(Para, { center: true, large: true },
                    React.createElement(FormattedCurrency, { isCents: true, currency: currency, value: amount }),
                    " Credit"),
                mainMessage && React.createElement(LeftAlign, null, mainMessage),
                invoiceToMessage && React.createElement(LeftAlign, null, invoiceToMessage),
                messages && messages.map(function (message) { return React.createElement(LeftAlign, null, message); })),
            React.createElement(TenantWalletBalanceQuery, null, function (_a) {
                var tenantWallet = _a.data.tenantWallet;
                return (React.createElement(GreyCard, { medium: true },
                    React.createElement(InnerCard, null,
                        React.createElement(Row, { leftText: firstRow.label, rightText: firstRow.value }),
                        React.createElement(Row, { leftText: secondRow.label, rightText: secondRow.value }),
                        React.createElement(Row, { leftText: React.createElement(FormattedMessage, { id: dateText }), rightText: React.createElement(FormattedDate, { day: "numeric", month: "long", year: "numeric", value: createdAt }) }),
                        isBankTransfer ?
                            React.createElement(React.Fragment, null,
                                React.createElement(Row, { leftText: React.createElement(FormattedMessage, { id: "wallet.tenant.topUp.invoicePopUp.bank" }), rightText: BankName }),
                                React.createElement(Row, { leftText: React.createElement(FormattedMessage, { id: "wallet.tenant.topUp.invoicePopUp.bankAccountNumber" }), rightText: BankAccountNumber }),
                                React.createElement(Row, { isLast: true, leftText: React.createElement(FormattedMessage, { id: "wallet.tenant.topUp.invoicePopUp.bankSortCode" }), rightText: BankSortCode })) :
                            React.createElement(React.Fragment, null,
                                React.createElement(Row, { leftText: React.createElement(FormattedMessage, { id: "wallet.tenant.topUp.invoicePopUp.timeAdded" }), rightText: React.createElement(FormattedRelative, { value: createdAt }) }),
                                React.createElement(Row, { isLast: true, leftText: React.createElement(FormattedMessage, { id: "wallet.tenant.topUp.invoicePopUp.wallet" }), rightText: React.createElement(FormattedCurrency, { isCents: false, currency: tenantWallet.currency, value: tenantWallet.availableBalance }), pending: pending && React.createElement(FormattedCurrency, { isCents: true, currency: tenantWallet.currency, value: amount }) }))),
                    React.createElement(StyledButton, { primary: true, large: true, full: true, onClick: onClose },
                        React.createElement(FormattedMessage, { id: "wallet.tenant.topUp.invoicePopUp.button" }))));
            })));
    };
    TopUpConfirmationPopup.defaultProps = {
        pending: false
    };
    return TopUpConfirmationPopup;
}(Component));
export default injectIntl(TopUpConfirmationPopup);
